module.exports = __webpack_public_path__ + "static/img/scbyfpq.63f8c57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scbyfpq.png
// module id = GIdq
// module chunks = 1